import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import errorLogger from 'Root/errorLogger'
import { browserStorage } from 'Redux/services/storage'
import {
  SHOW_GOOGLE_SSO, SHOW_GOOGLE_SSO_APP,
} from 'Config/config'
import GoogleSSO from 'Components/GoogleSSO'
import GoogleSSOApp from 'Components/GoogleSSOApp'
// import { saveCredential, loadCredential } from 'Utils/biometricsUtils'
import { Input, PasswordInput, HiddenSubmit, SquareCheckboxWithLabel } from 'Components/Form'
import CryptoJs from 'crypto-js'
import {
  _Login, _Forgot, _SubmitCta, _LoginlMainError, _RememberMe, _RememberForgotContainer, _Divider,
} from './styles'

const useForm = ({ initialState }) => {
  const [values, updateValues] = useState(initialState || {})

  return {
    formValues: values,
    handleFormUpdate: e => {
      updateValues({ ...values, [e.id]: e.value })
    },
  }
}


const bs = browserStorage()

export const EMAIL_SECRET = '44947913c4cf@fje$fie8,z'
export const USER_EMAIL_KEY = 'rememberMe'

const formInitialState = { email: '', password: '' }

export const getEncryptedText = ({ message }) => {
  try {
    return CryptoJs.AES.encrypt(message, EMAIL_SECRET).toString()
  } catch(e) {
    errorLogger('remember me encrypt ' + e)
    return null
  }
}
export const getDecryptedText = ({ message }) => {
  try {
    return CryptoJs.AES.decrypt(message, EMAIL_SECRET).toString(CryptoJs.enc.Utf8)
  } catch(e) {
    errorLogger('remember me  decrypt ' + e)
    return null
  }
}
const Login = (
  {
    onLogin, onPassReset, errorMessage, userDataIsFetching,
    listingCard, formTitle, loginMainError, loginPage,
    isMobileApp,
  },
) => {
  const [rememberMe, updateRememberEmail] = useState(!!bs.getItem(USER_EMAIL_KEY))
  const { formValues, handleFormUpdate } = useForm({ initialState: formInitialState })
  // const biometricsEnabled = JSON.parse(bs.getItem('biometricsEnabled')) || false

  useEffect(() => {
    // if(isMobileApp && biometricsEnabled) {
    //   loadCredential({ onLogin })
    // }
    const encryptedUserEmail = bs.getItem(USER_EMAIL_KEY)
    if(encryptedUserEmail) {
      const userEmail = getDecryptedText({ message: encryptedUserEmail })
      // if remember user name is set
      handleFormUpdate({
        id: 'email',
        value: userEmail,
      })
    }
  }, [])

  useEffect(() => {
    const login = document.getElementById('login')
    if(login) login.focus()
  })

  // adding onKeyDown to enable done/enter to submit in safari
  const onKeyDown = (e) => {
    if(e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault()
      onLogin(formValues.email, formValues.password)
    }
  }

  // send login request and save user email if remember email check box is set
  const doLogin = () => {
    // set remember user id
    if(rememberMe) {
      bs.setItem(USER_EMAIL_KEY, getEncryptedText({ message: formValues.email }))
    }
    onLogin(formValues.email, formValues.password, isMobileApp)
    // if(isMobileApp) {
    //   saveCredential({
    //     username: formValues.email,
    //     password: formValues.password })
    // }
  }


  const disableSubmit = (
    userDataIsFetching || !formValues.email || !formValues.password
  )

  return (
    <_Login listingCard={listingCard} data-test-id={listingCard ? 'loginListingCard' : 'loginModal'}>
      <h4>{`Log in ${!formTitle ? 'to Your Account' : 'to ' + formTitle}`}</h4>
      {
        loginMainError &&
        <_LoginlMainError>{loginMainError}</_LoginlMainError>
      }
      {/*  eslint-disable-next-line */}
      <form
        name={'loginModalForm'}
        onSubmit={e => {
          e.preventDefault()
          onLogin()
        }}
        onKeyDown={onKeyDown}
      >
        <Input
          id="email"
          type="email"
          animatedLabel="Email Address"
          onChange={handleFormUpdate}
          value={formValues.email}
          autoComplete
        />
        <PasswordInput
          id="password"
          onChange={handleFormUpdate}
          errorText={errorMessage}
        />
        <_RememberForgotContainer loginPage={loginPage} wrap justify="between" align="center">
          <_RememberMe align="center" loginPage={loginPage}>
            <SquareCheckboxWithLabel
              id="rememberMe"
              label="Remember my email"
              checked={rememberMe}
              onChange={() => {
                if(rememberMe) {
                  bs.removeItem(USER_EMAIL_KEY)
                }
                updateRememberEmail(!rememberMe)
              }}
            />
          </_RememberMe>
          <_Forgot
            data-test-id="forgot"
            onClick={onPassReset}
            type="button"
          >
            Forgot Password?
          </_Forgot>
        </_RememberForgotContainer>
        <HiddenSubmit />
      </form>

      <div data-test-id="submitCtaDiv">
        <_SubmitCta
          primary
          medium
          onClick={doLogin}
          disabled={disableSubmit}
          data-test-id={'submitCta'}
          loading={userDataIsFetching}
        >
          Log in
        </_SubmitCta>
        <_Divider>or</_Divider>
        {!isMobileApp ? (SHOW_GOOGLE_SSO && <GoogleSSO loginPage={loginPage} text={'Sign In'}/>) :
          (SHOW_GOOGLE_SSO_APP && <GoogleSSOApp loginPage={loginPage} text={'Sign In'}/>)}
      </div>

    </_Login>
  )
}


Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
  onPassReset: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  userDataIsFetching: PropTypes.bool,
  listingCard: PropTypes.bool,
  loginPage: PropTypes.bool,
  isMobileApp: PropTypes.bool,
  formTitle: PropTypes.string,
  loginMainError: PropTypes.string,
}

export default Login
